import { ReactNode } from "react";
import './input-number.css'
import TextInput from "./input-text.tsx";
import { PropertiesAutoFillState } from "../../state/types.ts";

export default function NumberInput (props: {
	label?: string,
	value: number,
  auto_filled?: PropertiesAutoFillState,
  step: number,
  min?: number,
  max?: number,
  decimals?:number,
  placeholder?:string | number,
  unit?: string,
  disabled?: boolean,
  infoButton?: ReactNode,
  onChange: (value: number | undefined) => void,
  onBlur?: () => void,
  validate?: (value: string) => Promise<boolean>, 
}){
  return <TextInput infoButton={props.infoButton} auto_filled={props.auto_filled} type="number" min={props.min} max={props.max} decimals={props.decimals} onBlur={props.onBlur} step={props.step} postfix={props.unit} label={props.label} value={(props.value ?? "").toString()} placeholder={props.placeholder ? props.placeholder.toString() : ""}  disabled={props.disabled} onChange={(value)=>{
    if(value){
      props.onChange(parseFloat(value));
    }else{
      props.onChange(undefined);
    }
  }}
  validate={props.validate}/>
}
